import { useParams } from 'react-router-dom';
import React from 'react';
import { useGuaranteedPriceProcess } from '../../../hooks/useGuaranteedPrice/useGuaranteedPriceProcess';
import ModalGuaranteedPriceProcess from './ModalGuaranteedPriceProcess';
import { t } from '../../common/Translate';
import { Auth } from '../../../config/configuration/react';

const GuranteedPriceProcess = () => {
  const { recordId } = useParams();
  const { textBody, newGuaranteedOpen, toggleNewGuarantted, cancelGuaranteed, confirmGuaranteed } =
    useGuaranteedPriceProcess(recordId);
  return (
    !Auth.roleViewerAccess() && (
      <div className="ml-2 mt-4">
        <div>
          <span className="font-weight-bold">{t(`acceptNewTradeInPrice`)}</span>
        </div>
        <div className="mt-4">
          <button type="button" className="btn btn-3 mr-5" onClick={() => toggleNewGuarantted('noAcceptGuaranteed')}>
            {t('no')}
          </button>
          <button type="button" className="btn btn-1" onClick={() => toggleNewGuarantted('acceptGuaranteed')}>
            {t('yes')}
          </button>
        </div>
        <ModalGuaranteedPriceProcess
          cancelGuaranteed={cancelGuaranteed}
          confirmGuaranteed={() => confirmGuaranteed(recordId)}
          toggle={toggleNewGuarantted}
          isOpen={newGuaranteedOpen}
          textBody={textBody}
        />
      </div>
    )
  );
};
export default GuranteedPriceProcess;
